import { IsDefined, IsNotEmpty } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class QuotePolicyDataService extends DataService<typeof Model.Bookings.Logic.ViewModels.QuotePolicyItem, Model.Bookings.Logic.ViewModels.QuotePolicyItem, QuotePolicyItem> {
	protected map(entity: Model.Bookings.Logic.ViewModels.QuotePolicyItem): QuotePolicyItem {
		return new QuotePolicyItemModel(entity);
	}

	static make(ctx?: any): QuotePolicyDataService {
		return new QuotePolicyDataService(ctx, ctx => ctx.QuotePolicies);
	}

	add(defaultLanguage: string, type: number): Promise<QuotePolicyItem> {
		const entity = new Model.Bookings.Logic.ViewModels.QuotePolicyItem();

		entity.type = type;
		(entity as any).dynamicProperties = {
			displayName: {
				[defaultLanguage]: ''
			}
		};

		return this.create(() => entity);
	}
}

export class QuotePolicyItemModel extends EntityModel<Model.Bookings.Logic.ViewModels.QuotePolicyItem, QuotePolicyItem> implements QuotePolicyItem {
	@property<QuotePolicyItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<QuotePolicyItemModel>(o => o.entity.isActive, (o, value) => o.entity.isActive = value)
	public isActive: boolean;

	@property<QuotePolicyItemModel>(o => o.entity.type, (o, value) => o.entity.type = value)
	public type: number;

	@property<QuotePolicyItemModel>(o => o.entity.productId, (o, value) => o.entity.productId = value)
	@IsDefined({ message: 'Product is required' })
	@IsNotEmpty({ message: 'Product is required' })
	public productId: number;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	public dynamicProperties: any;

	@property<QuotePolicyItemModel>(o => o.entity.rules, (o, value) => o.entity.rules = value)
	public rules: PolicyRuleItem[];
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-policies/form/quote-policy-form.data.ts